module.exports = __webpack_public_path__ + "img/ABRAZADERA DE TENSION.0d45e202.jpg";